import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  menu: {
    color: theme.palette.text.secondary,
  },
  menuItem: {
    "&.MuiMenuItem-root": {
      padding: "20px 15px",
    },
    // Active item styling
    "&.RaMenuItemLink-active": {
      color: theme.palette.text.secondary,
      fontWeight: 600,
      backgroundColor: "rgba(108, 0, 136, 0.2)",
      "& .MuiListItemIcon-root": {
        color: `${theme.palette.text.secondary} !important`,
      },
    },
    "&:hover": {
      backgroundColor: theme.palette.text.secondary,
    },
  },
}));

export default useStyles;
